import axios, {endpoints} from 'src/utils/axios';

import {setSession} from './utils';
import {STORAGE_KEY} from './constant';

// ----------------------------------------------------------------------

export type SignInParams = {
  identifier?: string;
  email?: string;
  password: string;
};

export type SignUpParams = {
  username?: string;
  identifier?: string;
  email?: string;
  password: string;
  firstName: string;
  lastName: string;
};

/** **************************************
 * Sign in
 *************************************** */
export const signInWithPassword = async ({identifier, password}: SignInParams): Promise<void> => {
  try {
    const params = {identifier, password};

    const res = await axios.post(endpoints.auth.signIn, params);

    const {accessToken, refreshToken} = res.data;

    if (!accessToken) {
      throw new Error('Access token not found in response');
    }

    setSession(accessToken);
  } catch (error) {
    console.error('Error during sign in:', error);
    throw error;
  }
};

/** **************************************
 * Sign up
 *************************************** */
export const signUp = async ({
                               email,
                               password,
                               firstName,
                               lastName,
                             }: SignUpParams): Promise<void> => {
  const params = {
    email,
    password,
    firstName,
    lastName,
  };

  try {
    const res = await axios.post(endpoints.auth.signUp, params);

    const {accessToken} = res.data;

    if (!accessToken) {
      throw new Error('Access token not found in response');
    }

    sessionStorage.setItem(STORAGE_KEY, accessToken);
  } catch (error) {
    console.error('Error during sign up:', error);
    throw error;
  }
};

/** **************************************
 * Sign out
 *************************************** */
export const signOut = async (): Promise<void> => {
  try {
    await setSession(null);
  } catch (error) {
    console.error('Error during sign out:', error);
    throw error;
  }
};
